<template>
    <div style="height: 30vh;  margin: auto">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
            <el-col :xl="3" :lg="3" :md="3" :sm="3" :xs="4" style="line-height: 28px;text-align: right;margin-right: 10px;">场景名称：</el-col>
            <el-col :xl="19" :lg="19" :md="19" :sm="19" :xs="18">
                <el-input class="inline-input" size="mini" placeholder="请输入场景名称" style="width: 80%" v-model="form.sceneName"></el-input>
            </el-col>
        </el-col>
            <son-scene v-for="(item,index) in deviceLinkageConditions" :key="index" :spaceList="spaceList" :index="index" :item="item" :deviceLinkageConditions="deviceLinkageConditions" @deleteIndex="del"
                       @add="add"
                       @uploadData="getData"></son-scene>
        <el-col :span="24" style="height: 8px;" class="hidden-sm-and-up"></el-col>
        <el-col :span="24" style="height: 13px;" class="hidden-md-and-down"></el-col>
    </div>
</template>

<script>
    import SonScene from "@/views/basic_operations/strategy/linkage/simple/edit/SonScene.vue";
    import {getSpaceTreeData} from '@/network/space-info';
    import lodash from "lodash";
    export default {
        name: "Scene",
        props:["dialogData"],
        components:{SonScene},
        data (){
         return {
             form:{
                 sceneName:'',
                 deviceLinkageConditions:[],
                 deviceLinkageActions:[]
             },
             conditionForm:{
                 logicalOperator:0,
                 spaceId:'',
                 spaceName:'',
                 gatewaySn:'',
                 deviceId:'',
                 deviceName:'',
                 triggerType:'',
                 devicePointId:'',
                 devicePointName:'',
                 valueLogicalOperator:'',
                 pointValue:''
             },
             deviceLinkageConditions:[],
             valueLogicalOperatorList:[
                 {value:0,label:'小于'},
                 {value:1,label:'大于'},
                 {value:2,label:'等于'},
                 {value:3,label:'不等于'},
                 {value:4,label:'大于等于'},
                 {value:5,label:'小于等于'}
             ],
             deviceList:[
             ],
             pointList:[
             ],
             spaceList:[
             ],
             triggerTypeList:[
                 {value:0,label:'每次'},
                 {value:1,label:'单次'}
             ],
         }
        },
        created() {
            this.add();
            this.getSpaceTreeData();
            if(this.dialogData){
                this.form=lodash.cloneDeep(this.dialogData);
                if(this.dialogData.deviceLinkageConditions!=undefined && this.dialogData.deviceLinkageConditions.length>0){
                    this.deviceLinkageConditions=lodash.cloneDeep(this.dialogData.deviceLinkageConditions);
                }
            }
        },
        watch:{
            dialogData(newVal){
                console.log("变化");
                this.form=newVal;
            }
        },
        methods:{
            add(){
                let form={
                    logicalOperator:0,
                    spaceId:'',
                    spaceName:'',
                    deviceId:'',
                    deviceName:'',
                    gatewaySn:'',
                    devicePointId:'',
                    devicePointName:'',
                    valueLogicalOperator:'',
                    pointValue:''
                };
                this.deviceLinkageConditions.push(form);
            },
            // delete
            del (index) {
                    this.deviceLinkageConditions.splice(index, 1)
            },
            //  get the data from child
            getData: function (val) {
                let index = val.index;
                this.deviceLinkageConditions[index] = val.data
            },
            getForm(){
                if(!this.$stringIsNotNullAndEmpty(this.form.sceneName)){
                    this.$message.error("请输入场景名");
                    return null;
                }
                for(let item of this.deviceLinkageConditions){
                    if(item.logicalOperator.length<=0){
                        this.$message.error("请选择条件");
                        return null;
                    }
                    if(item.spaceName==undefined || item.spaceName.length<=0){
                        this.$message.error("请选择空间");
                        return null;
                    }
                    if(item.deviceName==undefined || item.deviceName.length<=0){
                        this.$message.error("请选择设备");
                        return null;
                    }
                    if(item.devicePointName==undefined || item.devicePointName.length<=0){
                        this.$message.error("请选择测点");
                        return null;
                    }
                    if(item.valueLogicalOperator==undefined || item.valueLogicalOperator.length<=0){
                        this.$message.error("请选择测点的逻辑运算");
                        return null;
                    }
                    if(!this.$stringIsNotNullAndEmpty(item.pointValue)){
                        this.$message.error("请输入测点值");
                        return null;
                    }
                    if(item.triggerType==undefined || item.triggerType.length<=0){
                        this.$message.error("请选择测点的触发类型");
                        return null;
                    }
                }
                this.form.deviceLinkageConditions=this.deviceLinkageConditions;
                return this.form;
            },
            getSpaceTreeData() {
                getSpaceTreeData().then(res => {
                    if (res.code === 0) {
                        // 将树转换成需要的格式
                        let tree = res.data;
                        this.spaceList = this.getTree(tree);
                    }
                });
            },
            getTree(tree) {
                // 返回的数组
                let treeList = [];
                for (let item of tree) {
                    // 创建上级选项
                    let param = {value: item.id, label: item.title};
                    if (item.children != undefined) {
                        // 给上级选项添加下级选项
                        param.children = this.getTree(item.children);
                    }
                    treeList.push(param)
                }
                return treeList;
            },
        }
    }
</script>

<style scoped>

</style>
<style>

</style>
